import { useMemo } from "react";

export const useStopsById = itinerary => {
    return useMemo(() => {
        if (!itinerary) {
            return {};
        }
        const stops = itinerary.itineraryData.stops;
        return stops.reduce(
            (result, stop) => ({
                ...result,
                [stop.id]: stop,
            }),
            {},
        );
    }, [itinerary]);
};

export const useStopIdsByPlaceStartId = itinerary => {
    return useMemo(() => {
        if (!itinerary) {
            return {};
        }
        const stops = itinerary.itineraryData.stops;
        return stops.reduce((result, stop, index) => {
            if (stop.type !== "place_start") {
                return result;
            }
            const _stops = stops.slice(index + 1);
            const stopsUntilPlaceEndIds = _stops
                .slice(
                    0,
                    _stops.findIndex(stop => stop.type === "place_end"),
                )
                .filter(stop => stop.type === "stop")
                .map(stop => stop.id);
            return {
                ...result,
                [stop.id]: stopsUntilPlaceEndIds,
            };
        }, {});
    }, [itinerary]);
};
